module.exports = "mutation {\n    toggleMyTipsDisplay(enabled: false)\n}\n"